// TaskStatusModal — confirm a status change and (optionally) add a remark
// before the update is saved. Portaled to body.

import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X, RefreshCw } from "lucide-react";
import "../../css/tasks/taskdetail.css";

const LABELS = {
  pending: "Pending",
  inProgress: "In Progress",
  completed: "Completed",
  overdue: "Overdue",
};

export default function TaskStatusModal({ currentStatus, newStatus, saving, onSave, onClose }) {
  const [remark, setRemark] = useState("");

  return createPortal(
    <div className="td-overlay" onClick={onClose}>
      <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="td-header">
          <h3 className="td-title">
            <RefreshCw size={16} style={{ marginRight: 6, verticalAlign: "-2px" }} />
            Update Status
          </h3>
          <button className="td-close" type="button" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="td-body">
          <p className="td-desc" style={{ marginBottom: 14 }}>
            Change status from{" "}
            <strong>{LABELS[currentStatus] || currentStatus}</strong> to{" "}
            <strong>{LABELS[newStatus] || newStatus}</strong>.
          </p>

          <label className="tr-label">Remark (optional)</label>
          <textarea
            className="tr-textarea"
            rows={3}
            autoFocus
            placeholder="Add a comment about this status update..."
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />

          <div className="tr-actions">
            <button className="tr-btn-cancel" type="button" onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button
              className="tr-btn-save"
              type="button"
              onClick={() => onSave(remark.trim())}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save Update"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
